import styled, { css } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS } from '@components/web/src/styles';

export const ModalOverlay = styled(Flexbox)<{ $withoutDefaultPadding?: boolean; $isAnimated?: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 100000;
  background: rgb(0 0 0 / 75%);
  backdrop-filter: blur(4px);
  padding: ${({ $withoutDefaultPadding, theme }) => {
    if ($withoutDefaultPadding) return '0';
    if (theme?.isKioskRootElementType) return '128px';
    return '16px';
  }};

  ${({ $isAnimated }) =>
    $isAnimated &&
    css`
      opacity: 0;
      animation: fadeIn 0.3s forwards;

      @keyframes fadeIn {
        to {
          opacity: 1;
        }
      }
    `};
`;

export const ModalContent = styled(Flexbox)<{
  $isTransparent?: boolean;
  $modalContentWidth?: string;
  $modalContentHeight?: string;
  $minModalContentHeight: string;
  $maxModalContentHeight?: string;
  $noScroll?: boolean;
}>`
  width: ${({ $modalContentWidth }) => $modalContentWidth};
  height: ${({ $modalContentHeight }) => $modalContentHeight};
  min-height: ${({ $minModalContentHeight }) => $minModalContentHeight};
  max-height: ${({ $maxModalContentHeight }) => $maxModalContentHeight};
  background: ${({ $isTransparent }) => ($isTransparent ? 'transparent' : COLORS.base.white)};
  overflow-y: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
